"use client";

import { useEffect, useState, useContext, useRef } from "react";
import { GAEvent, GA_EVENTS } from "@/helpers/gaEvents";
import styles from "./SideButtons.module.scss";
import cn from "clsx";
import { pushToDataLayer } from "@/helpers/gtag";
import { IModalActions, ModalTypes } from "@/types/modal";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import { ModalContext } from "@/context/ModalContext";
import CloseScholarship from "@/SvgIcons/CloseScholarship";
import { imgPathReplace } from "@/helpers/imgPathReplace";


const SideButtons = ({ data, modalType, pageType, associatedPrograms }) => {
  const { modalDispatch } = useContext(ModalContext);
  const { STICKY_CTA_TEL, STICKY_CTA_WHATSAPP, CALL_CHAT_INTERACTION } = GAEvent;
  const [isToolTipVisible,setIsToolTipVisible] = useState(false);

  const [isVisible, setIsVisible] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isMobileViewDisabled, setIsMobileViewDisabled] = useState(true);
  const res = data?.filter((x, i) => x?.enabled && i !== 0);
  const timeoutRef = useRef(null);  

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.location.pathname === "/" || window.location.pathname === "/mba-campus-immersion-online" || pageType === "programDetails" || pageType === "specialization" || window.location.pathname === "/scholarship") {
        if (window.scrollY > 0.7 * window.innerHeight) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      } else {
        setIsVisible(false);
      }
      const tooltipSeen = sessionStorage.getItem('tooltipTestScholarship');

      if (tooltipSeen !== 'true') {
        const isHomePage = window.location.pathname === '/';
        const isTestScholarshipEnabled = process.env.NEXT_PUBLIC_TEST_SCHOLARSHIP === '1';
        const hasScrolledEnough = window.scrollY > 0;
      
        if (isHomePage && isTestScholarshipEnabled && hasScrolledEnough) {
          setIsToolTipVisible(true);
        }
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    if(window.innerWidth < 1201){ 
      setIsMobileView(true);
    } else{
      setIsMobileView(false);
    }
    setIsMobileViewDisabled(false);

    if (sessionStorage.getItem('tooltipTestScholarship') === 'true'){
      return;
    }else{
      if(window.location.pathname === "/" && process.env.NEXT_PUBLIC_TEST_SCHOLARSHIP=='1'){
       timeoutRef.current = setTimeout(() => {
          setIsToolTipVisible(true);
        }, 3000);
        
        return () => {
          clearTimeout(timeoutRef.current);
          window.removeEventListener("scroll", toggleVisibility);
        };
      }
    }

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const handleClick = (item) => {
    
    const itemUrl = item?.url || "#";
    if (itemUrl.includes("tel")) {
      // for tel
      const gaData = GA_EVENTS.get(STICKY_CTA_TEL);
      pushToDataLayer(gaData);
      const gaData2 = {
        ...GA_EVENTS.get(CALL_CHAT_INTERACTION),
        cta_text: "call_us",
        section_name: "sticky_sidetray",
        page_type: getGlobalStateValue("pageType"),
      };
      pushToDataLayer(gaData2);

      window.webengage.track("Call Us Clicked",{
        "Section Name": "sticky_sidetray"
      })

    } else if (itemUrl.includes("whatsapp")) {
      // for whatsapp
      const gaData = GA_EVENTS.get(STICKY_CTA_WHATSAPP);
      pushToDataLayer(gaData);

      const gaData2 = {
        ...GA_EVENTS.get(CALL_CHAT_INTERACTION),
        cta_text: "whatsapp_chat",
        section_name: "sticky_sidetray",
        page_type: getGlobalStateValue("pageType"),
      };
      pushToDataLayer(gaData2);
    }
  };

  const renderItemUrl = (itemUrl) => {
    return itemUrl.includes("tel") && !isMobileView ? "#" : itemUrl;
  };

  const fireGTOpenCTA = ()  => {

    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType,
        modalData: { associatedPrograms }
      },
    });


   setTimeout(() => {

     pushToDataLayer({
       event: "lead_initiate",
       cta_text: "Apply Now",
       section_name: "side_widget",
       header_title: "header_title",
       page_type: getGlobalStateValue("pageType"),
       page_url: location.pathname,
     });

     updateStateSession({
       sectionTitle: "header_title",
       leadStartingCta: "Apply Now",
       parentSection: "side_widget",
     });
     
   }, 2000); 
  }
  


  const fireGtEvents = () => {

      modalDispatch({
        type: IModalActions.OpenModal,
        data: {
          modalType: ModalTypes.CallUsModal,
        },
      });

      pushToDataLayer({
        ...GA_EVENTS.get(CALL_CHAT_INTERACTION),
        cta_text: "call_us",
        section_name: "sticky_sidetray",
        page_type: getGlobalStateValue("pageType")
      })

      window.webengage.track("Call Us Clicked", {
        "Section Name": "sticky_sidetray"
      })
  }

  const handleRedirect = () =>{

    sessionStorage.setItem('tooltipTestScholarship', 'true');
    setIsToolTipVisible(false);
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType:ModalTypes.ConnectModalScholarship,
        modalData:{isTestScholarship:true}
      },
    });

    setTimeout(()=>{
    
          pushToDataLayer({
            event: "test_initiate",
            cta_text: "Start_Test",
            section_name: "Popup",
            page_type: getGlobalStateValue("pageType"),
            page_url: window.location.href,
          });
    
          updateStateSession({
            parentSection: "Popup",
          })

        },1500)
  }
  const handleClose = () => {
    setIsToolTipVisible(false);
    sessionStorage.setItem('tooltipTestScholarship', 'true');
    clearTimeout(timeoutRef.current);
    setTimeout(() => {
      modalDispatch({
        type: IModalActions.UpdateModal,
        data: { modalType: ModalTypes.CallingSticky_Modal, isModalOpen: true },
      });
    }, 30000);
  }

  return (
    <>
      <div className={styles.sideBtnRoot}>
      {isToolTipVisible && (
        <div className={cn(styles.tooltipDiv, isVisible ? styles.tooltipAboveButton : styles.tooltipAtBottom)}>
          <div className={styles.tooltipClose} onClick={handleClose}><CloseScholarship/></div>
          <div className={styles.tooltipPara}>
            <img className={styles.tooltipImage} src={imgPathReplace("https://amityonline.com/_s/Frame_5_1_0cb1a8e22e.webp")} alt="Logo"></img>
            <div className="mt-[0.5rem]">
            <span className="flex justify-center gap-[0.3rem]">Take Our Instant <span className={styles.toolParaDanger}> 15 Mins</span></span>
            <p> Scholarship Test Today!</p>
            </div>
          </div>
          <button className={styles.tooltipButton} onClick={handleRedirect}>START TEST</button>
        </div>
      )}
        <div className={`sideButtons flex flex-col ${styles.buttonPosition} ${styles.btnWrapper}`}>
          {res?.map((item, i) => (
            <div className={styles.imgSize} key={i}>
              {item.title === "call-button" && !isMobileView ? (
                <button
                  onClick={fireGtEvents}
                  className={styles.stickCTAbtn}
                  disabled={isMobileViewDisabled}
                >
                  <img
                    id="call-icon"
                    className={cn("aspect-square", styles.imgIconSize)}
                    src={item?.source?.data?.[0]?.attributes?.url}
                    alt={item?.alt || "call us"}
                    loading="lazy"
                    title="call us"
                  />
                </button>
              ) : (
                <>
                  <a
                    href={renderItemUrl(item?.url) || "#"}
                    onClick={(e) => {
                      if (isMobileViewDisabled) {
                        e.preventDefault();
                      }
                      handleClick(item)
                    }}
                    target={item?.target?.[0] || "_self"}
                  >
                    <img
                      id="wa-icon"
                      className={cn("aspect-square", styles.imgIconSize)}
                      src={item?.source?.data?.[0]?.attributes?.url}
                      alt={item?.alt || "wa-icon"}
                      loading="lazy"
                      title="wa-icon"
                    />
                  </a>
                </>
              )}
            </div>
          ))}
          {isVisible && (
            <div className={styles.stickyApplymob}>
              <div onClick={fireGTOpenCTA} className={styles.stickyApplyBtn}>
                APPLY NOW
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default SideButtons;
